import { useDispatch, useSelect } from "@wordpress/data";
import type React from "react";
import { Modal } from "../components/modal";
import "./auth-modal.scss";
import { authStore } from "./auth-store";
import { defaultCopyForIntent } from "./default-copy";
import { CreateAccountStage } from "./stages/create-account-stage";
import { EmailEntryStage } from "./stages/email-entry-stage";
import { JoinExistingStage } from "./stages/join-existing-stage";
import { PasswordStage } from "./stages/password-stage";
import { SuccessStage } from "./stages/success-stage";

export const AuthModal: React.FC = () => {
	const isOpen = useSelect((select) => select(authStore).isOpen(), []);
	const stage = useSelect((select) => select(authStore).getStage(), []);
	const intent = useSelect((select) => select(authStore).getIntent(), []);
	const copy = useSelect((select) => select(authStore).getCopy(), []);
	const { closeModal } = useDispatch(authStore);

	if (!isOpen) return null;

	const fallback = defaultCopyForIntent(intent);
	const title = copy?.modalTitle ?? fallback.modalTitle;

	let body: React.ReactNode = null;
	switch (stage) {
		case "emailEntry":
			body = <EmailEntryStage copySubmitOverride={copy?.submitText} />;
			break;
		case "password":
			body = <PasswordStage copySubmitOverride={copy?.submitText} />;
			break;
		case "createAccount":
			body = (
				<CreateAccountStage
					copySubmitOverride={copy?.submitText}
					accountCreationNoteOverride={copy?.accountCreationNote}
				/>
			);
			break;
		case "joinExisting":
			body = <JoinExistingStage copySubmitOverride={copy?.submitText} />;
			break;
		case "success":
			body = (
				<SuccessStage
					title={copy?.successTitle ?? fallback.successTitle}
					message={copy?.successMessage ?? fallback.successMessage}
				/>
			);
			break;
	}

	const handleClose = () => {
		closeModal();
		if (stage === "success") {
			window.location.reload();
		}
	};

	return (
		<Modal isOpen={isOpen} onClose={handleClose} title={title}>
			{body}
		</Modal>
	);
};
